import Dataset from "./Dataset";

export default class Zones extends Dataset {
  type = "feature";
}
